import * as categoryStyles from "../../../styles/events/event-page.module.scss";

import React from "react";
import clsx from "clsx";

const Category = ({
    clicked,
    label,
    variant,
    disabled,
    basecolor,
    handleClick,
    clickOff,
    ariaLabel,
    ariaDescribedBy,
    lang,
    notFocusable,
    underline,
    disablePointer
}) => {
    let grey = "var(--light-grey-color)";
    let red = "var(--red-color)";
    let white = "var(--white-color)";

    const getColor = React.useCallback((basecolor) => {
        switch (variant) {
            case "contained":
                return clicked ? basecolor : white;
            case "color":
                return clicked ? white : basecolor;
            case "light":
                return clicked ? basecolor : grey;
            default:
                return clicked ? white : basecolor;
        }
    }, [clicked, grey, white, variant])

    const getBackgroundColor = React.useCallback((basecolor) => {
        switch (variant) {
            case "contained":
                return clicked ? white : basecolor;
            case "color":
                return clicked ? basecolor : white;
            case "light":
                return white;
            default:
                return clicked ? basecolor : white;
        }
    }, [clicked, white, variant]);

    let color = getColor(basecolor ? basecolor : red);
    let backgroundColor = getBackgroundColor(basecolor ? basecolor : red);

    const conditionalAttrLink = {}

    if (underline) {
        conditionalAttrLink["aria-pressed"] = true;
    }

    return (
        <button
            {...conditionalAttrLink}
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            lang={lang}
            className={clsx(categoryStyles.actuChip, {[categoryStyles.chipHover]: !clickOff})}
            tabIndex={notFocusable ? -1 : 0}
            onClick={() => {
                if (!disabled && handleClick) handleClick();
            }}
            onKeyDown={() => {
                if (!disabled && handleClick) handleClick();
            }}
            disabled={disabled}
            style={{
                border: `1px solid ${color}`,
                color: color,
                backgroundColor: backgroundColor, ...disablePointer,
                textDecoration: underline ? "underline" : undefined,
                textUnderlinePosition: underline ? "under" : undefined,
            }}
        >
            {label}
        </button>
    );
};

export default Category;
